/**
 * Patient report REQUESTS
 */

import { PATIENT_REPORT_URL } from '../apiUrl'
import Axios from './axiosSetup';

/**
 * Patient report Request
 * @param patientId 
 * @param formData 
 * @returns 
 */
export const UpdatePatientReport = (patientId: string, formData: object) => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.put(`${PATIENT_REPORT_URL}/${patientId}`, formData);
}

/**
* GET Patient report Request
* @returns 
*/
export const GetPatientReport = (id: string) => {
 Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
 return Axios.get(`${PATIENT_REPORT_URL}/${id}`);
}

/**
 * Patient report Request
 * @returns 
 */
export const CountPatientRdvClick = () => {
  Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return Axios.post(`${PATIENT_REPORT_URL}/count-click`);
}


/**
 * Patient report Request
 * @param patientId 
 * @param formData 
 * @returns 
 */
export const UpdatePatientData = (formData: object) => {
  return Axios.post(`${PATIENT_REPORT_URL}/update-patient-data`, formData);
}